import React from 'react';
import git from '../../githublogo1.png';
import linkedIn from '../../linkedinlogo.png';
import youtube from '../../youtube.png';
import devpost from '../../devpost.svg';

class Title extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
          title: this.props.title, 
        };
    }

    render() {
      return (
        <div className="title">
          <h1>{this.props.title}</h1>
          <a class="profileLogo" href="https://github.com/shreyaj1212"><img src={git}></img></a>
          <a class="profileLogo" href="https://www.linkedin.com/in/shreya-jain-150661185"><img src={linkedIn}></img></a>
          <a href="https://www.youtube.com/channel/UCtAJU6p5d3-PiL3pHZQKmyw"><img src={youtube}></img></a>
        </div>
      );
    }
  }

export { Title }; 